export default "__VITE_ASSET__BEaSlzfU__"